(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name HistorialPacientes
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('HistorialPacientes', HistorialPacientes);

    HistorialPacientes.$inject = ["HistorialService","GenerallabService","VideoconsultaService","$uibModal","UserService","$timeout","$location",'$anchorScroll','Upload'];

    function HistorialPacientes(HistorialService,GenerallabService,VideoconsultaService,$uibModal,UserService,$timeout,$location,$anchorScroll,Upload)
    {
        var vm = this;
        vm.pacientes = "";
        vm.paciente = "";
        vm.videoconsulta = "";
        vm.videoconsultasList = "";
        vm.selected = false;
        vm.generalLab = GenerallabService;
        vm.filtros  = { nombre: "" };
        vm.sexos = "";
        vm.ficheros = [];
        vm.nombre = "";
        vm.editado = false;

          vm.getPacientes = function(){
       		    HistorialService.getPacientes(vm).then(function(data){ 
                vm.pacientes = data.pacientes;
          	})
       	  } 

       	  vm.pacienteSeleccionado = function(paciente_id){
            vm.selected = true;
                   console.log(vm.paciente.id);
            	HistorialService.pacienteId(paciente_id).then(function(data){
                  vm.paciente = data.paciente;
                  vm.videoconsulta = data.videoconsulta;
                  vm.consultas(vm.paciente.id);
             	})
        	} 
          vm.selected = false;

          
          vm.edit = function(form){
              HistorialService.editPaciente(vm).then(function(data){
                vm.paciente = data.paciente_edit;
                vm.editado = true;
                vm.getPacientes(); 
            })
          } 

          vm.consultas = function(paciente_id){
              VideoconsultaService.getConsultas(paciente_id).then(function(data){
                  vm.videoconsultasList = data.videoconsultas;
              })
          } 
          
          vm.getSexos = function(){
              HistorialService.getSexos(vm).then(function(data){ 
                vm.sexos = data.sexos;
            })
          }

         

          vm.uploadFiles = function (files) { 
          if (files && files.length) {
            for (var i = 0; i < files.length; i++) {
              Upload.upload({
                    url: '/ajax/subirdocumentacion',
                    data: { file: files[i] }
                }).then(function (resp) {
                    //onsole.log(resp);
                    vm.ficheros.push(resp.data);

                   if (vm.ficheros) {
                   }

                }, function (resp) {
                    //console.log('Error status: ' + resp.status);
                }, function (evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                });
            }
            //files = null;

              }
          }
         vm.modalEditar = "";
         vm.open = function () {
                vm.modalEditar = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title',
                  ariaDescribedBy: 'modal-body',
                  templateUrl: 'modanimal',
                  controller: function($scope, $timeout ){
                    $scope.hp = vm;
                    $scope.paciente = vm.paciente;
                    vm.editado = false; 
                    $timeout(function(){
                      $('#sexopaciente').select2("trigger", "select", {
                            data: { id: vm.paciente.sexo_id, text: vm.paciente.sexo.nombre }
                      });
                      $('#castradopaciente').select2("trigger", "select", {
                            data: { id: vm.paciente.castrado_id, text: vm.paciente.castrado.titulo }
                      });
                      $('#especiepaciente').select2("trigger", "select", {
                            data: { id: vm.paciente.especie_id, text: vm.paciente.especie.nombre }
                      });  
                      $('#razapaciente').select2("trigger", "select", {
                            data: { id: vm.paciente.raza, text: vm.paciente.raza_m.nombre }
                      });   
                      
                    },100);
                  },
                  size: 'lg',

                });

                 vm.ko = function () {
                  vm.modalEditar.close();
                    //modalInstance.dismiss('cancel');
                     console.log(vm.paciente.nombre);
                  };
              }; 

    }
})();